import request from "./request";
/**
 * 分页查询该专页未绑定的用户
 * @param pageId 专页id
 * @param pageNumber 当前页数
 * @param pageSize 页数大小
 */
export default async function getUnbindUserPage(params = {}) {
  const defaultParams = {
    pageNumber: 1,
    pageSize: 200,
  };
  return await request.get("/spin/dataAuthorization/getUnbindUserPage", {
    params: { ...defaultParams, ...params },
  });
}
